import type { ReactNode } from "react";

import { IconArrowRight, IconInbox, IconJunk, IconMailOpen, IconTrash, IconX } from "./icons.js";

/**
 * Balk met bulkacties zodra er berichten geselecteerd zijn.
 *
 * Op desktop staat hij boven de lijst; op mobiel neemt hij (via styles.css) de
 * plek en de vorm over van de vaste actiebalk onder een geopend bericht, zodat
 * de duim hem op dezelfde hoogte vindt.
 */

interface SelectionBarProps {
  count: number;
  /** false in de Prullenbak: daar is verwijderen definitief, geen bulkactie. */
  busy: boolean;
  /**
   * Welke kant de spamknop op wijst: "spam" in gewone mappen, "notSpam" in
   * Ongewenst. null laat de knop weg — in Verzonden en Concepten zegt hij
   * niets, en zonder map Ongewenst is er nergens om heen te verplaatsen.
   */
  junk: "spam" | "notSpam" | null;
  onMove: () => void;
  onJunk: () => void;
  onDelete: () => void;
  onMarkRead: () => void;
  onSelectAll: () => void;
  onCancel: () => void;
}

export function SelectionBar({
  count,
  busy,
  junk,
  onMove,
  onJunk,
  onDelete,
  onMarkRead,
  onSelectAll,
  onCancel,
}: SelectionBarProps): ReactNode {
  return (
    <div className="selection-bar" role="toolbar" aria-label="Acties voor de selectie">
      <span className="selection-count" aria-live="polite">
        {count === 1 ? "1 bericht" : `${count} berichten`}
      </span>

      <button type="button" className="button button--ghost" onClick={onMove} disabled={busy}>
        <IconArrowRight />
        <span className="button-label">Verplaatsen</span>
      </button>

      {junk !== null && (
        <button type="button" className="button button--ghost" onClick={onJunk} disabled={busy}>
          {junk === "spam" ? <IconJunk /> : <IconInbox />}
          <span className="button-label">{junk === "spam" ? "Ongewenst" : "Geen spam"}</span>
        </button>
      )}

      <button type="button" className="button button--ghost" onClick={onMarkRead} disabled={busy}>
        <IconMailOpen />
        <span className="button-label">Gelezen</span>
      </button>

      <button type="button" className="button button--danger" onClick={onDelete} disabled={busy}>
        <IconTrash />
        <span className="button-label">Verwijderen</span>
      </button>

      <button type="button" className="button button--ghost selection-all" onClick={onSelectAll}>
        <span className="button-label">Alles</span>
      </button>

      <button type="button" className="button button--ghost" onClick={onCancel}>
        <IconX />
        <span className="button-label">Annuleren</span>
      </button>
    </div>
  );
}
